import { DeviceServiceMock } from "./device.types";

export const mockDeviceService = (): DeviceServiceMock => ({
  fetchDeviceById: jest.fn(),
  fetchDeviceAlerts: jest.fn(),
  createDeviceV2: jest.fn(),
  updateDeviceV2: jest.fn(),
  changeStatus: jest.fn(),
});
